export default {
	data() {
		return {
			kitchenDayPower: [
				['2021-10-01T00:00:00Z',  2927.47],
				['2021-10-02T00:00:00Z',  1167.92],
				['2021-10-03T00:00:00Z',  1232.91],
				['2021-10-04T00:00:00Z',  3709.54],
				['2021-10-05T00:00:00Z',  3961.94],
				['2021-10-06T00:00:00Z',  3706.12],
				['2021-10-07T00:00:00Z',  3330.26],
				['2021-10-08T00:00:00Z',  3105.01],
				['2021-10-09T00:00:00Z',  1270.74],
				['2021-10-10T00:00:00Z',  1169.66],
				['2021-10-11T00:00:00Z',  4117.28],
				['2021-10-12T00:00:00Z',  3559.00],
				['2021-10-13T00:00:00Z',  3065.75],
				['2021-10-14T00:00:00Z',  2982.23],
				['2021-10-15T00:00:00Z',  2461.30],
				['2021-10-16T00:00:00Z',  1141.73],
				['2021-10-17T00:00:00Z',  1133.80],
				['2021-10-18T00:00:00Z', 	3074.75],
				['2021-10-19T00:00:00Z', 	3115.15],
				['2021-10-20T00:00:00Z', 	3107.63],
				['2021-10-21T00:00:00Z', 	2815.80],
				['2021-10-22T00:00:00Z', 	2181.22],
				['2021-10-23T00:00:00Z', 	1121.97],
				['2021-10-24T00:00:00Z', 	1101.39],
				['2021-10-25T00:00:00Z', 	2346.05],
				['2021-10-26T00:00:00Z',  2215.47],
				['2021-10-27T00:00:00Z',  1970.89],
				['2021-10-28T00:00:00Z',  2030.98],
				['2021-10-29T00:00:00Z',  1776.63],
				['2021-10-30T00:00:00Z',  1054.51],
				['2021-10-31T00:00:00Z',  1021.49],
			],
			kitchenNightPower: [
				['2021-10-01T00:00:00Z',  643.96],
				['2021-10-02T00:00:00Z',  464.88],
				['2021-10-03T00:00:00Z',  440.09],
				['2021-10-04T00:00:00Z',  512.46],
				['2021-10-05T00:00:00Z',  624.87],
				['2021-10-06T00:00:00Z',  515.34],
				['2021-10-07T00:00:00Z',  538.24],
				['2021-10-08T00:00:00Z',  567.54],
				['2021-10-09T00:00:00Z',  459.33],
				['2021-10-10T00:00:00Z',  496.94],
				['2021-10-11T00:00:00Z',  544.30],
				['2021-10-12T00:00:00Z',  541.33],
				['2021-10-13T00:00:00Z',  545.26],
				['2021-10-14T00:00:00Z',  554.33],
				['2021-10-15T00:00:00Z',  556.27],
				['2021-10-16T00:00:00Z',  450.50],
				['2021-10-17T00:00:00Z',  456.72],
				['2021-10-18T00:00:00Z', 	532.97],
				['2021-10-19T00:00:00Z', 	547.46],
				['2021-10-20T00:00:00Z', 	559.50],
				['2021-10-21T00:00:00Z', 	519.99],
				['2021-10-22T00:00:00Z', 	629.58],
				['2021-10-23T00:00:00Z', 	435.67],
				['2021-10-24T00:00:00Z', 	434.77],
				['2021-10-25T00:00:00Z', 	523.01],
				['2021-10-26T00:00:00Z',  568.26],
				['2021-10-27T00:00:00Z',  377.61],
				['2021-10-28T00:00:00Z',  351.52],
				['2021-10-29T00:00:00Z',  431.62],
				['2021-10-30T00:00:00Z',  442.42],
				['2021-10-31T00:00:00Z',  385.46],
			],
			mbportDayPower: [
				['2021-10-01T00:00:00Z',  43981.10],
				['2021-10-02T00:00:00Z',  32804.31],
				['2021-10-03T00:00:00Z',  33029.53],
				['2021-10-04T00:00:00Z',  47313.78],
				['2021-10-05T00:00:00Z',  48115.81],
				['2021-10-06T00:00:00Z',  47301.72],
				['2021-10-07T00:00:00Z',  46430.90],
				['2021-10-08T00:00:00Z',  46247.95],
				['2021-10-09T00:00:00Z',  33224.23],
				['2021-10-10T00:00:00Z',  33163.15],
				['2021-10-11T00:00:00Z',  46575.87],
				['2021-10-12T00:00:00Z',  47756.30],
				['2021-10-13T00:00:00Z',  46412.50],
				['2021-10-14T00:00:00Z',  46068.71],
				['2021-10-15T00:00:00Z',  44274.55],
				['2021-10-16T00:00:00Z',  32702.13],
				['2021-10-17T00:00:00Z',  32685.71],
				['2021-10-18T00:00:00Z', 	45560.13],
				['2021-10-19T00:00:00Z', 	46327.36],
				['2021-10-20T00:00:00Z', 	46141.14],
				['2021-10-21T00:00:00Z', 	45566.69],
				['2021-10-22T00:00:00Z', 	44601.61],
				['2021-10-23T00:00:00Z', 	34043.94],
				['2021-10-24T00:00:00Z', 	34003.59],
				['2021-10-25T00:00:00Z', 	45298.45],
				['2021-10-26T00:00:00Z',  46397.25],
				['2021-10-27T00:00:00Z',  12296.3],
				['2021-10-28T00:00:00Z',  11514.19],
				['2021-10-29T00:00:00Z',  11013.51],
				['2021-10-30T00:00:00Z',  4036.35],
				['2021-10-31T00:00:00Z',  3992.69],
			],
			mbportNightPower: [
				['2021-10-01T00:00:00Z',  15821.34],
				['2021-10-02T00:00:00Z',  13473.01],
				['2021-10-03T00:00:00Z',  13552.65],
				['2021-10-04T00:00:00Z',  15249.75],
				['2021-10-05T00:00:00Z',  16004.65],
				['2021-10-06T00:00:00Z',  15944.02],
				['2021-10-07T00:00:00Z',  16003.16],
				['2021-10-08T00:00:00Z',  15890.57],
				['2021-10-09T00:00:00Z',  13718.97],
				['2021-10-10T00:00:00Z',  13708.48],
				['2021-10-11T00:00:00Z',  15432.23],
				['2021-10-12T00:00:00Z',  15967.34],
				['2021-10-13T00:00:00Z',  15722.84],
				['2021-10-14T00:00:00Z',  15622.06],
				['2021-10-15T00:00:00Z',  15696.38],
				['2021-10-16T00:00:00Z',  13460.01],
				['2021-10-17T00:00:00Z',  13461.06],
				['2021-10-18T00:00:00Z', 	15268.41],
				['2021-10-19T00:00:00Z', 	15596.37],
				['2021-10-20T00:00:00Z', 	15490.44],
				['2021-10-21T00:00:00Z', 	15453.37],
				['2021-10-22T00:00:00Z', 	15748.19],
				['2021-10-23T00:00:00Z', 	13922.80],
				['2021-10-24T00:00:00Z', 	14028.57],
				['2021-10-25T00:00:00Z', 	15771.22],
				['2021-10-26T00:00:00Z',  14998.24],
				['2021-10-27T00:00:00Z',  3430.12],
				['2021-10-28T00:00:00Z',  3484.01],
				['2021-10-29T00:00:00Z',  3167.17],
				['2021-10-30T00:00:00Z',  1734.95],
				['2021-10-31T00:00:00Z',  1707.11],
			],
			electrakDayPower: [
				['2021-10-01T00:00:00Z',  71865.73],
				['2021-10-02T00:00:00Z',  62760.28],
				['2021-10-03T00:00:00Z',  62588.27],
				['2021-10-04T00:00:00Z',  83067.40],
				['2021-10-05T00:00:00Z',  88893.93],
				['2021-10-06T00:00:00Z',  83855.62],
				['2021-10-07T00:00:00Z',  87157.18],
				['2021-10-08T00:00:00Z',  79208.63],
				['2021-10-09T00:00:00Z',  64160.00],
				['2021-10-10T00:00:00Z',  63661.03],
				['2021-10-11T00:00:00Z',  84731.62],
				['2021-10-12T00:00:00Z',  91721.50],
				['2021-10-13T00:00:00Z',  86341.11],
				['2021-10-14T00:00:00Z',  80272.56],
				['2021-10-15T00:00:00Z',  70391.35],
				['2021-10-16T00:00:00Z',  61567.87],
				['2021-10-17T00:00:00Z',  61130.51],
				['2021-10-18T00:00:00Z', 	76991.20],
				['2021-10-19T00:00:00Z', 	78911.20],
				['2021-10-20T00:00:00Z', 	78594.17],
				['2021-10-21T00:00:00Z', 	75269.14],
				['2021-10-22T00:00:00Z', 	70397.38],
				['2021-10-23T00:00:00Z', 	62741.09],
				['2021-10-24T00:00:00Z', 	61911.91],
				['2021-10-25T00:00:00Z', 	71793.50],
				['2021-10-26T00:00:00Z',  76584.78],
				['2021-10-27T00:00:00Z',  72716.26],
				['2021-10-28T00:00:00Z',  69504.98],
				['2021-10-29T00:00:00Z',  68415.02],
				['2021-10-30T00:00:00Z',  58984.98],
				['2021-10-31T00:00:00Z',  58487.89],
			],
			electrakNightPower: [
				['2021-10-01T00:00:00Z',  27837.37],
				['2021-10-02T00:00:00Z',  25685.72],
				['2021-10-03T00:00:00Z',  25586.40],
				['2021-10-04T00:00:00Z',  25805.40],
				['2021-10-05T00:00:00Z',  27920.12],
				['2021-10-06T00:00:00Z',  27377.50],
				['2021-10-07T00:00:00Z',  27771.52],
				['2021-10-08T00:00:00Z',  27125.13],
				['2021-10-09T00:00:00Z',  26346.83],
				['2021-10-10T00:00:00Z',  26113.06],
				['2021-10-11T00:00:00Z',  25971.32],
				['2021-10-12T00:00:00Z',  27378.02],
				['2021-10-13T00:00:00Z',  26067.70],
				['2021-10-14T00:00:00Z',  26336.63],
				['2021-10-15T00:00:00Z',  26603.58],
				['2021-10-16T00:00:00Z',  25111.33],
				['2021-10-17T00:00:00Z',  24977.38],
				['2021-10-18T00:00:00Z', 	25083.25],
				['2021-10-19T00:00:00Z', 	26082.46],
				['2021-10-20T00:00:00Z', 	26118.25],
				['2021-10-21T00:00:00Z', 	25713.79],
				['2021-10-22T00:00:00Z', 	26257.48],
				['2021-10-23T00:00:00Z', 	25122.21],
				['2021-10-24T00:00:00Z', 	25492.45],
				['2021-10-25T00:00:00Z', 	25320.80],
				['2021-10-26T00:00:00Z',  24018.16],
				['2021-10-27T00:00:00Z',  24374.53],
				['2021-10-28T00:00:00Z',  24420.78],
				['2021-10-29T00:00:00Z',  24320.28],
				['2021-10-30T00:00:00Z',  24302.1],
				['2021-10-31T00:00:00Z',  23970.34],
			],
			acDayPower: [
				['2021-10-01T00:00:00Z',  30095.29],
				['2021-10-02T00:00:00Z',  18627.29],
				['2021-10-03T00:00:00Z',  22690.04],
				['2021-10-04T00:00:00Z',  32109.13],
				['2021-10-05T00:00:00Z',  33324.69],
				['2021-10-06T00:00:00Z',  31898.75],
				['2021-10-07T00:00:00Z',  30866.12],
				['2021-10-08T00:00:00Z',  32773.63],
				['2021-10-09T00:00:00Z',  20942.13],
				['2021-10-10T00:00:00Z',  19042.63],
				['2021-10-11T00:00:00Z',  32196.01],
				['2021-10-12T00:00:00Z',  33304.84],
				['2021-10-13T00:00:00Z',  31767.84],
				['2021-10-14T00:00:00Z',  32317.92],
				['2021-10-15T00:00:00Z',  28498.41],
				['2021-10-16T00:00:00Z',  17817.22],
				['2021-10-17T00:00:00Z',  18045.35],
				['2021-10-18T00:00:00Z', 	30418.35],
				['2021-10-19T00:00:00Z', 	33345.05],
				['2021-10-20T00:00:00Z', 	30862.69],
				['2021-10-21T00:00:00Z', 	31138.67],
				['2021-10-22T00:00:00Z', 	29318.39],
				['2021-10-23T00:00:00Z', 	21472.36],
				['2021-10-24T00:00:00Z', 	18224.13],
				['2021-10-25T00:00:00Z', 	30245.34],
				['2021-10-26T00:00:00Z',  31593.24],
				['2021-10-27T00:00:00Z', 5679.81],
				['2021-10-28T00:00:00Z',  5981.71],
				['2021-10-29T00:00:00Z',  5150.7],
				['2021-10-30T00:00:00Z',  4895.88],
				['2021-10-31T00:00:00Z',  4882.37],
			],
			acNightPower: [
				['2021-10-01T00:00:00Z',  8025.97],
				['2021-10-02T00:00:00Z',  7489.73],
				['2021-10-03T00:00:00Z',  7564.35],
				['2021-10-04T00:00:00Z',  7556.28],
				['2021-10-05T00:00:00Z',  7926.68],
				['2021-10-06T00:00:00Z',  7565.30],
				['2021-10-07T00:00:00Z',  7757.78],
				['2021-10-08T00:00:00Z',  7855.59],
				['2021-10-09T00:00:00Z',  7675.35],
				['2021-10-10T00:00:00Z',  7593.73],
				['2021-10-11T00:00:00Z',  7565.40],
				['2021-10-12T00:00:00Z',  7740.30],
				['2021-10-13T00:00:00Z',  7860.18],
				['2021-10-14T00:00:00Z',  7575.56],
				['2021-10-15T00:00:00Z',  7675.12],
				['2021-10-16T00:00:00Z',  7210.38],
				['2021-10-17T00:00:00Z',  7243.59],
				['2021-10-18T00:00:00Z', 	7375.28],
				['2021-10-19T00:00:00Z', 	7948.63],
				['2021-10-20T00:00:00Z', 	7784.06],
				['2021-10-21T00:00:00Z', 	7128.91],
				['2021-10-22T00:00:00Z', 	7263.29],
				['2021-10-23T00:00:00Z', 	7535.11],
				['2021-10-24T00:00:00Z', 	7389.51],
				['2021-10-25T00:00:00Z', 	7469.01],
				['2021-10-26T00:00:00Z',  7521.03],
				['2021-10-27T00:00:00Z',  2252.17],
				['2021-10-28T00:00:00Z',  2156.94],
				['2021-10-29T00:00:00Z',  2164.37],
				['2021-10-30T00:00:00Z',  2002.93],
				['2021-10-31T00:00:00Z',  1905.45],
			],
			lightDayPower: [
				['2021-10-01T00:00:00Z',  79356.88],
				['2021-10-02T00:00:00Z',  11838.63],
				['2021-10-03T00:00:00Z',  35296.69],
				['2021-10-04T00:00:00Z',  79717.33],
				['2021-10-05T00:00:00Z',  80909.89],
				['2021-10-06T00:00:00Z',  78500.58],
				['2021-10-07T00:00:00Z',  74396.18],
				['2021-10-08T00:00:00Z',  74555.25],
				['2021-10-09T00:00:00Z',  24703.72],
				['2021-10-10T00:00:00Z',  11833.34],
				['2021-10-11T00:00:00Z',  79988.84],
				['2021-10-12T00:00:00Z',  79231.52],
				['2021-10-13T00:00:00Z',  78071.09],
				['2021-10-14T00:00:00Z',  78698.11],
				['2021-10-15T00:00:00Z',  70682.50],
				['2021-10-16T00:00:00Z',  11827.65],
				['2021-10-17T00:00:00Z',  11835.59],
				['2021-10-18T00:00:00Z', 	75445.74],
				['2021-10-19T00:00:00Z', 	78536.68],
				['2021-10-20T00:00:00Z', 	76209.78],
				['2021-10-21T00:00:00Z', 	75004.30],
				['2021-10-22T00:00:00Z', 	73062.21],
				['2021-10-23T00:00:00Z', 	26505.45],
				['2021-10-24T00:00:00Z', 	11839.53],
				['2021-10-25T00:00:00Z', 	66209.19],
				['2021-10-26T00:00:00Z',  66562.66],
				['2021-10-27T00:00:00Z',  62516.84],
				['2021-10-28T00:00:00Z',  64557.87],
				['2021-10-29T00:00:00Z',  64492.41],
				['2021-10-30T00:00:00Z',  9896.15],
				['2021-10-31T00:00:00Z',  10340.38],
			],
			lightNightPower: [
				['2021-10-01T00:00:00Z',  4974.72],
				['2021-10-02T00:00:00Z',  4878.14],
				['2021-10-03T00:00:00Z',  4878.41],
				['2021-10-04T00:00:00Z',  4886.70],
				['2021-10-05T00:00:00Z',  6736.64],
				['2021-10-06T00:00:00Z',  4880.85],
				['2021-10-07T00:00:00Z',  4882.05],
				['2021-10-08T00:00:00Z',  4877.80],
				['2021-10-09T00:00:00Z',  4935.70],
				['2021-10-10T00:00:00Z',  4873.40],
				['2021-10-11T00:00:00Z',  4880.60],
				['2021-10-12T00:00:00Z',  4882.53],
				['2021-10-13T00:00:00Z',  4880.30],
				['2021-10-14T00:00:00Z',  4878.56],
				['2021-10-15T00:00:00Z',  4882.87],
				['2021-10-16T00:00:00Z',  4994.72],
				['2021-10-17T00:00:00Z',  4875.28],
				['2021-10-18T00:00:00Z', 	4894.50],
				['2021-10-19T00:00:00Z', 	4957.71],
				['2021-10-20T00:00:00Z', 	4886.90],
				['2021-10-21T00:00:00Z', 	4883.82],
				['2021-10-22T00:00:00Z', 	4888.17],
				['2021-10-23T00:00:00Z', 	4868.99],
				['2021-10-24T00:00:00Z', 	4883.09],
				['2021-10-25T00:00:00Z', 	4877.66],
				['2021-10-26T00:00:00Z',  4092.44],
				['2021-10-27T00:00:00Z',  4348.45],
				['2021-10-28T00:00:00Z',  4631.92],
				['2021-10-29T00:00:00Z',  4096.98],
				['2021-10-30T00:00:00Z',  4096.68],
				['2021-10-31T00:00:00Z',  4079.79],
			],
			overallDayPower: [
				['2021-10-01T00:00:00Z',  230921.8],
				['2021-10-02T00:00:00Z',  118306.7],
				['2021-10-03T00:00:00Z',  153265.9],
				['2021-10-04T00:00:00Z',  247793.1],
				['2021-10-05T00:00:00Z',  255174.7],
				['2021-10-06T00:00:00Z',  245264.6],
				['2021-10-07T00:00:00Z',  242465.5],
				['2021-10-08T00:00:00Z',  242941.6],
				['2021-10-09T00:00:00Z',  139516],
				['2021-10-10T00:00:00Z',  120780.9],
				['2021-10-11T00:00:00Z',  248135.3],
				['2021-10-12T00:00:00Z',  255890.1],
				['2021-10-13T00:00:00Z',  246768.6],
				['2021-10-14T00:00:00Z',  240201.5],
				['2021-10-15T00:00:00Z',  219529.9],
				['2021-10-16T00:00:00Z',  116242.4],
				['2021-10-17T00:00:00Z',  116222.2],
				['2021-10-18T00:00:00Z', 	231970.4],
				['2021-10-19T00:00:00Z', 	240238.2],
				['2021-10-20T00:00:00Z', 	234056.1],
				['2021-10-21T00:00:00Z', 	231534.3],
				['2021-10-22T00:00:00Z', 	224226.7],
				['2021-10-23T00:00:00Z', 	141361],
				['2021-10-24T00:00:00Z', 	119631.5],
				['2021-10-25T00:00:00Z', 	227234.9],
				['2021-10-26T00:00:00Z',  232434.5],
				['2021-10-27T00:00:00Z',  221896.59],
				['2021-10-28T00:00:00Z',  223546.42],
				['2021-10-29T00:00:00Z',  221551.6],
				['2021-10-30T00:00:00Z',  119943.87],
				['2021-10-31T00:00:00Z',  120495.74],
			],
			overallNightPower: [
				['2021-10-01T00:00:00Z',  52955.46],
				['2021-10-02T00:00:00Z',  48334.82],
				['2021-10-03T00:00:00Z',  48444.77],
				['2021-10-04T00:00:00Z',  50051.54],
				['2021-10-05T00:00:00Z',  55556.38],
				['2021-10-06T00:00:00Z',  52203.84],
				['2021-10-07T00:00:00Z',  53032.08],
				['2021-10-08T00:00:00Z',  52300.14],
				['2021-10-09T00:00:00Z',  49716.39],
				['2021-10-10T00:00:00Z',  49511.47],
				['2021-10-11T00:00:00Z',  50948.7],
				['2021-10-12T00:00:00Z',  52221.13],
				['2021-10-13T00:00:00Z',  52854.88],
				['2021-10-14T00:00:00Z',  51724.66],
				['2021-10-15T00:00:00Z',  51739.73],
				['2021-10-16T00:00:00Z',  46483.3],
				['2021-10-17T00:00:00Z',  47566.17],
				['2021-10-18T00:00:00Z', 	49240.33],
				['2021-10-19T00:00:00Z', 	51125.54],
				['2021-10-20T00:00:00Z', 	50757.46],
				['2021-10-21T00:00:00Z', 	49915.75],
				['2021-10-22T00:00:00Z', 	51247.73],
				['2021-10-23T00:00:00Z', 	48532.96],
				['2021-10-24T00:00:00Z', 	49066.87],
				['2021-10-25T00:00:00Z', 	50712.49],
				['2021-10-26T00:00:00Z',  50742.52],
				['2021-10-27T00:00:00Z',  50947.71],
				['2021-10-28T00:00:00Z',  51316.74],
				['2021-10-29T00:00:00Z',  51465.82],
				['2021-10-30T00:00:00Z',  49476.72],
				['2021-10-31T00:00:00Z',  48857.44],
			],
		}
	}
}
